
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
class DeleteBoxQuest extends Vue {
  @Prop({ default: null }) readonly title!: string;
  @Prop({ default: false }) readonly message!: string;
  @Prop({ default: false }) readonly idText!: string;
  @Prop({ default: null }) readonly data!: unknown;
  @Prop({ default: null }) readonly type!: string;
  slug = "";
  showError = false;

  cancel(): void {
    this.slug = "";
    this.$bvModal.hide("team-modal-delete-quest");
  }
  deleteItem(): void {
    if (this.slug === this.idText) {
      this.showError = false;

      this.$bvModal.hide("team-modal-delete-quest");
      this.slug = "";
      this.$emit("deleteItem", this.type);
    } else {
      this.showError = true;
    }
  }
}

export default DeleteBoxQuest;
